import { useEffect } from 'react';

export default function LegalNotice() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-left">
        <h1 className="font-bebas text-4xl font-thin text-gray-900 mb-8">
          Aviso Legal
        </h1>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            1. Datos Identificativos
          </h2>
          <p className="text-gray-600 font-montserrat">
            En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos: la empresa titular de dominio web es **El Txoko** (en adelante El Txoko), con domicilio a estos efectos en Carrer Gregal, 11, Binisafua, Menorca, 07711, España. Correo electrónico de contacto: info@txoko.com del sitio web.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            2. Usuarios
          </h2>
          <p className="text-gray-600 font-montserrat">
            El acceso y/o uso de este portal de El Txoko atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            3. Uso del Portal
          </h2>
          <p className="text-gray-600 font-montserrat">
            https://donweb.com/es-int/ proporciona el acceso a multitud de informaciones, servicios, programas o datos (en adelante, "los contenidos") en Internet pertenecientes a El Txoko o a sus licenciantes a los que el USUARIO pueda tener acceso. El USUARIO asume la responsabilidad del uso del portal. Dicha responsabilidad se extiende al registro que fuese necesario para acceder a determinados servicios o contenidos. En dicho registro el USUARIO será responsable de aportar información veraz y lícita. Como consecuencia de este registro, al USUARIO se le puede proporcionar una contraseña de la que será responsable, comprometiéndose a hacer un uso diligente y confidencial de la misma.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            4. Protección de Datos
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko cumple con las directrices de la Ley Orgánica 15/1999 de 13 de diciembre de Protección de Datos de Carácter Personal, el Real Decreto 1720/2007 de 21 de diciembre por el que se aprueba el Reglamento de desarrollo de la Ley Orgánica y demás normativa vigente en cada momento, y vela por garantizar un correcto uso y tratamiento de los datos personales del usuario. Para ello, junto a cada formulario de recabo de datos de carácter personal, en los servicios que el usuario pueda solicitar a info@txoko.com, hará saber al usuario de la existencia y aceptación de las condiciones particulares del tratamiento de sus datos en cada caso, informándole de la responsabilidad del fichero creado, la dirección del responsable, la posibilidad de ejercer sus derechos de acceso, rectificación, cancelación u oposición, la finalidad del tratamiento y las comunicaciones de datos a terceros en su caso. Asimismo, El Txoko informa que da cumplimiento a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y el Comercio Electrónico y le solicitará su consentimiento al tratamiento de su correo electrónico con fines comerciales en cada momento.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            5. Propiedad Intelectual e Industrial
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.), titularidad de El Txoko o bien de sus licenciantes. Todos los derechos reservados. En virtud de lo dispuesto en los artículos 8 y 32.1, párrafo segundo, de la Ley de Propiedad Intelectual, quedan expresamente prohibidas la reproducción, la distribución y la comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización de El Txoko. El USUARIO se compromete a respetar los derechos de Propiedad Intelectual e Industrial titularidad de El Txoko. Podrá visualizar los elementos del portal e incluso imprimirlos, copiarlos y almacenarlos en el disco duro de su ordenador o en cualquier otro soporte físico siempre y cuando sea, única y exclusivamente, para su uso personal y privado. El USUARIO deberá abstenerse de suprimir, alterar, eludir o manipular cualquier dispositivo de protección o sistema de seguridad que estuviera instalado en el las páginas de El Txoko.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            6. Exclusión de Garantías y Responsabilidad
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            7. Modificaciones
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados en su portal.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            8. Enlaces
          </h2>
          <p className="text-gray-600 font-montserrat">
            En el caso de que en https://donweb.com/es-int/ se dispusiesen enlaces o hipervínculos hacía otros sitios de Internet, El Txoko no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso El Txoko asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno, ni garantizará la disponibilidad técnica, calidad, fiabilidad, exactitud, amplitud, veracidad, validez y constitucionalidad de cualquier material o información contenida en ninguno de dichos hipervínculos u otros sitios de Internet. Igualmente la inclusión de estas conexiones externas no implicará ningún tipo de asociación, fusión o participación con las entidades conectadas.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            9. Derecho de Exclusión
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko se reserva el derecho a denegar o retirar el acceso a portal y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            10. Generalidades
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko perseguirá el incumplimiento de las presentes condiciones así como cualquier utilización indebida de su portal ejerciendo todas las acciones civiles y penales que le puedan corresponder en derecho.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            11. Modificación de las Presentes Condiciones y Duración
          </h2>
          <p className="text-gray-600 font-montserrat">
            El Txoko podrá modificar en cualquier momento las condiciones aquí determinadas, siendo debidamente publicadas como aquí aparecen. La vigencia de las citadas condiciones irá en función de su exposición y estarán vigentes hasta que sean modificadas por otras debidamente publicadas.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="font-bebas text-2xl font-thin text-gray-800 mb-4">
            12. Legislación Aplicable y Jurisdicción
          </h2>
          <p className="text-gray-600 font-montserrat">
            La relación entre El Txoko y el USUARIO se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Menorca.
          </p>
        </section>
      </div>
    </div>
  );
}